if (!customElements.get('testimonials-section')) {
  class TestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        navPrev: '[nav-prev]',
        navNext: '[nav-next]',
        mediaSlider: '[media-slider]',
        contentSlider: '[content-slider]'
      };
      this.initSwipers();
    }

    initSwipers() {
      const swiperOptions = {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 1,
        shortSwipes: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchRatio: 1,
        grabCursor: true,
        keyboard: {
          enabled: true,
        },
      };

      const mediaSwiper = new Swiper(this.selectors.mediaSlider, {
        ...swiperOptions,
        controller: {
          control: null, // This will be set later
        },
      });

      const contentSwiper = new Swiper(this.selectors.contentSlider, {
        ...swiperOptions,
        navigation: {
          nextEl: this.selectors.navNext,
          prevEl: this.selectors.navPrev,
        },
        controller: {
          control: mediaSwiper,
        },
      });

      // Set the control for mediaSwiper after contentSwiper is initialized
      mediaSwiper.controller.control = contentSwiper;
    }
  }

  customElements.define('testimonials-section', TestimonialsSection);
}